import React, { useEffect, useRef } from 'react';
import ConditionalRender from '../../components/Common/ConditionalRender';
import { useHandleClickLoading } from '../../components/Common/utils';

const ArticlePopular = ({ data,loading }) => {
   
    const handleClickLoading = useHandleClickLoading();
  return (
    <div className="flex flex-col gap-2 basis-1/3">
    <span className="font-semibold">Artikel Populer</span>
    <div className="flex w-full h-[1px]  border-b border-[#2121211a] dark:border-[#f3f3f31a]" />
    <ConditionalRender
      productsData={data}
      isLoading={loading}
      model={"emptyData"}
    >
      {data.map((item, index) => (
        <button
        onClick={() => { handleClickLoading('/news/' + item.slug) }}
          key={index}
          className="flex flex-row gap-2 "
        >
          <div className="w-44 aspect-[3/2]">
            <img
              src={item.gambar}
              alt={item.judul}
              className="w-full h-full object-cover rounded-md pointer-events-none"
            />
          </div>
          <div className="flex w-full flex-col gap-2 justify-between h-full">
            <span className="text-sm text-left font-bold line-clamp-3">
              {item.judul}
            </span>
            <span className="text-xs text-left">{item.tanggal}</span>
          </div>
        </button>
      ))}
    </ConditionalRender>
  </div>
  );
}

export default ArticlePopular;
